import { gql } from "@apollo/client";

export const GET_GITHUB_STATS = gql`
  query GetGitHubStats {
    githubStats {
      profile {
        totalCommits
        totalPRs
        totalIssues
        totalReleases
        contributionsThisYear
        currentStreak
        longestStreak
        publicRepos
        privateRepos
      }
      languages {
        name
        commits
        percentage
        color
      }
      repositories {
        id
        name
        fullName
        description
        language
        stars
        forks
        watchers
        isPrivate
        htmlUrl
        createdAt
        updatedAt
        pushedAt
        commits
        pullRequests
        issues
        releases
      }
      activity {
        date
        commits
      }
      hourlyActivity {
        hour
        dayOfWeek
        commits
      }
      lastSyncAt
      lastSyncSuccess
    }
  }
`;

export const GET_GITHUB_REPOSITORY = gql`
  query GetGitHubRepository($id: ID!) {
    githubRepository(id: $id) {
      id
      name
      fullName
      description
      language
      stars
      forks
      watchers
      isPrivate
      htmlUrl
      createdAt
      updatedAt
      pushedAt
      pullRequests {
        id
        number
        title
        state
        htmlUrl
        createdAt
        updatedAt
        closedAt
        mergedAt
      }
      commits {
        id
        sha
        message
        authorName
        authorEmail
        authorDate
        committerDate
        htmlUrl
      }
      issues {
        id
        number
        title
        state
        htmlUrl
        createdAt
        updatedAt
        closedAt
      }
      releases {
        id
        tagName
        name
        body
        htmlUrl
        publishedAt
        createdAt
      }
    }
  }
`;

// GitHub Actions Telemetry Queries
export const GET_ACTIONS_SUMMARY = gql`
  query GetActionsSummary(
    $owner: String!
    $repo: String!
    $bucket: String!
    $since: DateTime
    $until: DateTime
  ) {
    actionsSummary(
      owner: $owner
      repo: $repo
      bucket: $bucket
      since: $since
      until: $until
    ) {
      workflowName
      periodStart
      periodEnd
      runs
      successes
      successRate
      avgRunSec
      avgQueueSec
      retryRate
    }
  }
`;

export const GET_ACTIONS_RUNS = gql`
  query GetActionsRuns(
    $owner: String!
    $repo: String!
    $workflowName: String
    $since: DateTime
    $until: DateTime
    $conclusion: String
  ) {
    actionsRuns(
      owner: $owner
      repo: $repo
      workflowName: $workflowName
      since: $since
      until: $until
      conclusion: $conclusion
    ) {
      runId
      repoOwner
      repoName
      workflowId
      workflowName
      event
      status
      conclusion
      runDurationSec
      queueTimeSec
      runStartedAt
      updatedAt
    }
  }
`;

export const GET_ACTIONS_BILLING = gql`
  query GetActionsBilling($scope: String!) {
    actionsBilling(scope: $scope) {
      scope
      asOfDate
      totalMinutesUsed
      includedMinutes
      totalPaidMinutesUsed
      ubuntuMinutes
      windowsMinutes
      macosMinutes
    }
  }
`;

export const GET_PR_FACTS = gql`
  query GetPRFacts(
    $owner: String!
    $repo: String!
    $since: DateTime
    $until: DateTime
  ) {
    prFacts(owner: $owner, repo: $repo, since: $since, until: $until) {
      repoOwner
      repoName
      number
      author
      createdAt
      mergedAt
      cycleTimeDays
    }
  }
`;
